<template>
    <div>
        <b-form-select
            size="sm"
            v-model="selected_legislation"
            :options="legislation_options"
            @change="onChangeLegislation($event)"
            class="b-form-input"
        ></b-form-select>

        <div v-if="validation_checks_loading_status == true" class="text-center mt-3">
            <b-spinner small type="grow"></b-spinner>
            Loading...
        </div>
        <div v-else class="table-responsive mt-3">
            <table class="table table-sm m-0 bordered sticky-header ">
                <thead>
                    <tr>
                        <!-- <th>#</th> -->
                        <th>Checks</th>
                        <th>Answers</th>
                    </tr>
                </thead>
                <!-- <tbody v-if="transformed_data !== null || transformed_data.length >= 1"> -->
                <tbody>
                    <tr v-for="question in computed_validation_checks" :key="question.id">
                        <!-- <td>{{ question.order }}.</td> -->
                        <td>{{ question.prompt }}</td>
                        <td class="column-width">
                            <b-form-select
                                cols-sm="4"
                                size="sm"
                                v-model="question.answer"
                                :options="question.options"
                                class="b-form-input select-width"
                                @change="onChange($event)"
                                :disabled="current_active_legislation != selected_legislation"
                            ></b-form-select>
                            <!-- {{ current_active_legislation }} ? {{ new_selected_legislation }} -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { suppliersComputed, certificateValidationComputed, certificateValidationMethods } from "../../state/helpers";
import { cloneDeep } from "lodash";

export default {
    data: () => ({
        active_legislation: null,
        selected_legislation: null,
        certificate_id: null,
        changed_answers: [],
        authentication_notes: "",
    }),
    computed: {
        ...suppliersComputed,
        ...certificateValidationComputed,
        computed_validation_checks() {
            //eslint-disable-next-line
            console.log(this.validation_checks_transformed);
            return cloneDeep(this.validation_checks_transformed);
        },
        legislation_options() {
            let data = this.regulation_versions;

            let t_data = data.map((obj) => {
                let start_date = obj.start_date.substring(0, 10);

                let end_date;

                if (obj.end_date == null) {
                    end_date = "current date";
                } else {
                    end_date = obj.end_date.substring(0, 10);
                }
                //set the active legislation:
                if (obj.active == 1) {
                    //sets active on html select
                    this.localSetSelectedLegislation(obj.id);
                    // sets these two as the same value, so that we can do v-if on buttons in the parent
                    this.setCurrentlActiveLegislation(obj.id); //sets it in state
                    //will be null when store is setup
                    if (this.new_selected_legislation == null) {
                        this.setNewSelectedLegislation(obj.id); //sets it in state
                    }
                }

                return { value: obj.id, text: `${obj.name} : ${start_date} - ${end_date}` };
            });

            return t_data;
        },
    },
    methods: {
        ...certificateValidationMethods,
        onChange(value) {
            const stringSplitToArray = value.split(".");
            const id = stringSplitToArray[0];
            const answer = stringSplitToArray[1];

            const index = this.changed_answers.findIndex((o) => o.check_id === id);

            if (index !== -1) {
                //eslint-disable-next-line
                // console.log("Found duplicate");
                this.changed_answers[index] = { check_id: id, answer: answer };
            } else {
                //eslint-disable-next-line
                // console.log("Not a duplicate");
                this.changed_answers.push({ check_id: id, answer: answer });
            }

            //pass it off to the state
            this.setAffidavitChecksChanged(this.changed_answers);
        },
        onChangeLegislation(event) {
            this.setNewSelectedLegislation(event); //sets it in state

            //eslint-disable-next-line
            console.log("onlegislation change", event);

            this.setValidationChecksByCertificate({ certificate_id: this.certificate_id, regulation_version_id: event });

            setTimeout(() => {
                this.localSetSelectedLegislation(event);
            }, 50);
            this.setAffidavitChecksChanged(-1); // !
        },
        localSetSelectedLegislation(id) {
            this.selected_legislation = id;
        },
    },
    mounted() {
        // the selected certificate id
        this.certificate_id = this.selected_supplier_certificate.id;

        this.setRegulationVersions({ certificate_id: this.certificate_id });

        let obj = {
            certificate_id: this.certificate_id,
            regulation_version_id: -1,
        };

        this.setValidationChecksByCertificate(obj);
    },
};
</script>

<style lang="scss" scoped>
.select-width {
    // width: 80px;
    max-width: 150px;
}
.column-width {
    width: 160px;
}
</style>
